import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-water-content',
  templateUrl: './water-content.component.html',
  styleUrls: ['./water-content.component.scss']
})
export class WaterContentComponent implements OnInit {
  @ViewChild('waterContentAmbientTemperatureInput') waterContentAmbientTemperatureInput!: ElementRef;
  @ViewChild('waterContentInput') waterContentInput!: ElementRef;
  @ViewChild('waterContentMeanValueStdDeviationInput') waterContentMeanValueStdDeviationInput!: ElementRef;
  @ViewChild('waterContentNumberOfMeasurementsInput') waterContentNumberOfMeasurementsInput!: ElementRef;
  waterContentAmbientTemperature!: string;
  waterContent!: string;
  waterContentMeanValueStdDeviation!: string;
  waterContentNumberOfMeasurements!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.waterContentAmbientTemperature = this.currentForm.get('waterContentAtAmbientTemperatures')?.value;
    this.waterContent = this.currentForm.get('waterContent')?.value;
    this.waterContentMeanValueStdDeviation = this.currentForm.get('waterContentMeanValueStdDeviation')?.value;
    this.waterContentNumberOfMeasurements = this.currentForm.get('waterContentNumberOfMeasurements')?.value;
  }

  public clearWaterContentAmbientTemperatureInputField() {
    this.waterContentAmbientTemperature = '';
    this.currentForm.patchValue({'waterContentAtAmbientTemperatures': ''});
  }

  public updateWaterContentAmbientTemperature(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.waterContentAmbientTemperature = '';
      }
    }
    this.currentForm.patchValue({'waterContentAtAmbientTemperatures': this.waterContentAmbientTemperature});
  }

  public cancelUpdateWaterContentAmbientTemperature() {
    this.waterContentAmbientTemperature = this.currentForm.get('waterContentAtAmbientTemperatures')?.value;
  }

  public clearWaterContentInputField() {
    this.waterContent = '';
    this.currentForm.patchValue({'waterContent': ''});
  }

  public updateWaterContent(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.waterContent = '';
      }
    }
    this.currentForm.patchValue({'waterContent': this.waterContent});
  }

  public cancelUpdateWaterContent() {
    this.waterContent = this.currentForm.get('waterContent')?.value;
  }

  public clearWaterContentMeanValueStdDeviationInputField() {
    this.waterContentMeanValueStdDeviation = '';
    this.currentForm.patchValue({'waterContentMeanValueStdDeviation': ''});
    this.errorCheck('waterContentMeanValueStdDeviation');
  }

  public updateWaterContentMeanValueStdDeviation(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.waterContentMeanValueStdDeviation = '';
      }
    }
    this.currentForm.patchValue({'waterContentMeanValueStdDeviation': this.waterContentMeanValueStdDeviation});
    this.errorCheck('waterContentMeanValueStdDeviation');
  }

  public cancelUpdateWaterContentMeanValueStdDeviation() {
    this.waterContentMeanValueStdDeviation = this.currentForm.get('waterContentMeanValueStdDeviation')?.value;
    this.errorCheck('waterContentMeanValueStdDeviation');
  }

  public clearWaterContentNumberOfMeasurementsInputField() {
    this.waterContentNumberOfMeasurements = '';
    this.currentForm.patchValue({'waterContentNumberOfMeasurements': ''});
    this.errorCheck('waterContentNumberOfMeasurements');
  }

  public updateWaterContentNumberOfMeasurements(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.waterContentNumberOfMeasurements = '';
      }
    }
    this.currentForm.patchValue({'waterContentNumberOfMeasurements': this.waterContentNumberOfMeasurements});
    this.errorCheck('waterContentNumberOfMeasurements');
  }

  public cancelUpdateWaterContentNumberOfMeasurements() {
    this.waterContentNumberOfMeasurements = this.currentForm.get('waterContentNumberOfMeasurements')?.value;
    this.errorCheck('waterContentNumberOfMeasurements');
  }

  public hasError(errorType: string, formFieldName: string): boolean {
    const control = this.currentForm.get(formFieldName);
    if(!control?.touched && !control?.dirty) {
      return false;
    }

    return control ? control.hasError(errorType) : false;
  }

  private errorCheck(formFieldName: string) {
    const targetControl = this.currentForm.get(formFieldName);
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
